import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { ADMIN_ROLES } from '../utils/constants';

RoleGuard.propTypes = {
  children: PropTypes.node,
  allowedRoles: PropTypes.array,
};

export default function RoleGuard({ children, allowedRoles }) {
  const { user } = useSelector((state) => state.auth);

  const hasAccess = allowedRoles.includes(user?.role);

  if (!hasAccess) {
    if (user?.role === ADMIN_ROLES.JUNIOR) {
      return <Navigate to="/user-management" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
